<template>
  <div class="container-fluid">
    <b-card>
      <div class="row mb-3">
        <router-link
          to="/principal/orders/add"
          class="btn btn-success"
          v-if="$can('create', 'Enterprise')"
        >
          <font-awesome-icon :icon="['fa', 'plus-square']" class="fontIconBtn"/>
          <span class="ml-2 fontButt"><b>Agregar Pedido</b></span>
        </router-link>
        <b-button variant="dark" type="submit" class="ml-2 btn col-q" @click="confirmationDialog('save')">
          <font-awesome-icon :icon="['fa', 'save']" class="fontIconBtn"/>
          <span class="ml-2 fontButt"><b>Guardar</b></span>
        </b-button>
        <b-button type="submit" class="ml-2 btn" variant="primary" @click="cargarCompras()">
          <font-awesome-icon :icon="['fa', 'money-check-alt']" class="fontIconBtn"/>
          <span class="ml-2 fontButt"><b>Cargar compra</b></span>
        </b-button>
      </div>
      <div class="col-lg-12 text-center mt-5 mb-2">
        <span><h2><b>{{nameMarca}}</b></h2></span>
        <span><h5><b>Total de Compra $ {{generalCost}}</b></h5></span>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <h6>Dia de compra</h6>
          <input type="date" v-model="today">
        </div>
      </div>
    <div class="mt-5">
      <b-button type="submit" class="btn col-lg-4 mb-3" variant="info" @click="addRow(user.enterprise_id)">
        <font-awesome-icon :icon="['fa', 'plus']" class="fontIconBtn"/>
      </b-button>
    </div>
    <div class="mt-4">
      <!-- {{ jsondata }} -->
      <!-- {{user}} -->
      <vue-excel-editor :ref="`grid${user.enterprise_id}`" :cell-style='mystyle' v-model="jsondata">
        <!-- <vue-excel-column field="id_client"  type="number" label="Id Cliente" width="70px" textTransform="uppercase" :change="changeClient" key-field/> -->
        <!-- <vue-excel-column field="fullname" label="Cliente" width="240px" textTransform="uppercase" readonly/> -->
        <vue-excel-column field="almacen" label="Almacen" width="120px" type="select" textTransform="uppercase" :change="changeAlmacen" :options="almacenes"  key-field/>
        <vue-excel-column field="proveedor" label="Proveedor" width="120px"  type="select"  textTransform="uppercase" :change="changeProveedor" :options="proveedores"/>
        <!-- <vue-excel-column field="marca" label="Marca" width="120px" textTransform="uppercase"/> -->
        <vue-excel-column field="modelo" label="Modelo" width="80px" type="select" textTransform="uppercase" :change="changeModel" :options="modelOptions"/>
        <!-- <vue-excel-column field="color" label="Color" width="80px" textTransform="uppercase"/> -->
        <!-- <vue-excel-column field="numero" label="Talla" width="80px" textTransform="uppercase"/> -->
        <vue-excel-column field="cantidad" label="Cantidad" type="number" textTransform="uppercase"/>
        <vue-excel-column field="precio"  type="number" label="Precio Cliente" :change="changeCost" width="80px"/>
        <vue-excel-column field="porcentaje_descuento" type="number" :change="changeDiscount" label="% Desc Cliente" width="60px"/>
        <vue-excel-column field="descuento" type="number" label="Desc $" :change="changeDiscountMoney" width="90px"/>
        <vue-excel-column field="venta"  label="Costo Cliente" width="80px" :change="changeClientPrice"/>
        <!-- <vue-excel-column field="porcentaje_descuento_nosotros" type="number" :change="changeDiscountAbout" label="% Nosotros" width="80px"/> -->
        <vue-excel-column field="costo_tienda" :change="changeCostoTienda" type="number" label="Costo Tienda" width="80px"/>
        <vue-excel-column field="mayoreo" :change="changeMayoreo" type="number" label="Precio de Mayoreo" width="80px"/>
        <vue-excel-column field="delivery_date"  label="Fecha" width="120px"/>
      </vue-excel-editor>
    </div>
    </b-card>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import { mapGetters } from 'vuex'
import formatData from '@/mixins/formatAxios'
import { BButton, BCard } from 'bootstrap-vue'

import moment from 'moment'
moment.locale('es')
// const axios = require('axios')
// var https = require('https')

export default {
  props: ['marca'],
  mixins: [formatData],
  components: {
    BButton,
    BCard
  },
  data () {
    return {
      today: moment().format('YYYY-MM-DD'),
      showEnterprises: false,
      selected: [], // Must be an array reference!
      options: [],
      modelOptions: [],
      proveedores: [],
      tabIndex: 0,
      generalCost: 0,
      id_provider: 0,
      nameMarca: '',
      rows: [],
      almacenes: [],
      isLoading: false,
      jsondata: [],
      optionsMarca: [],
      enterprises: [],
      dataEnterprises: [],
      barcodeValue: '123234345345',
      allProviders: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  watch: {
  },
  methods: {
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      } else {
        return ['bg-light', 'text-info']
      }
    },
    mystyle (rec, col) {
      if (col.name === 'catalogo') {
        return {
          'background-color': '#fbff008a'
        }
      } else if (col.name === 'marca') {
        return {
          background: '#ffb3077a'
        }
      } else if (col.name === 'precio') {
        return {
          background: 'rgb(239 89 157 / 60%)'
        }
      } else if (col.name === 'venta') {
        return {
          background: 'rgb(239 89 157 / 40%)'
        }
      } else if (col.name === 'costo_tienda') {
        return {
          background: 'rgb(18 255 32 / 60%)'
        }
      } else if (col.name === 'porcentaje_descuento') {
        return {
          background: 'rgb(56 166 210)'
        }
      } else if (col.name === 'porcentaje_descuento_nosotros') {
        return {
          background: 'rgb(56 166 210)'
        }
      } else if (col.name === 'descuento') {
        return {
          background: 'rgb(56 166 210 / 50%)'
        }
      } else if (col.name === 'fullname' || col.name === 'id_client') {
        return {
          background: '#28a7458c'
        }
      } else if (col.name === 'cantidad' || col.name === 'pagina' || col.name === 'comentario') {
        return {
          background: '#c146f078'
        }
      } else if (col.name === 'delivery_date') {
        return {
          background: '#53a9ffa1'
        }
      } else {
        return {
          'background-color': 'white'
        }
      }
    },
    onSort (...args) {
      console.log(args)
      const x = args.sort((a, b) => {
        if (a.user < b.user) return 1
        if (a.user > b.user) return -1
        return 0
      })
      console.log('this.dataEnterprises[args[0].empresa]', this.dataEnterprises[args[0].empresa])
      this.dataEnterprises[args[0].empresa] = x
    },
    async loadItems (marca, enterprise) {
      try {
        this.jsondata = []
        const items = {
          status: 8,
          provider_id: marca.id_provider,
          enterprise_id: enterprise.id
        }
        console.log('getOrders items', items)
        const response = await axiosAdelaService.post('/getOrders', items)
        console.log('getOrders', response)
        const xxd = []
        console.log(response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          if (response.data.totalRecords > 0) {
            let costoXD = 0
            for (const key in response.data.rows) {
              response.data.rows[key].orders.forEach((element, index) => {
                costoXD += parseFloat(element.costo_tienda)
                element.provider_id = marca.id_provider
                element.precio = parseFloat(element.precio).toFixed(2)
                element.descuento = parseFloat(element.descuento).toFixed(2)
                element.venta = parseFloat(element.venta).toFixed(2)
                this.jsondata.push(element)
                xxd.push(element)
              })
            }
            console.log(xxd)
            this.generalCost = costoXD
          }
          return xxd
        }
      } catch (error) {
        this.showError('No se pudieron obtener las empresas intentalo mas tarde.')
      }
    },
    async confirmationDialog (type) {
      let msg = ''
      console.log('llego a confirmar')
      // const data = selected > 0 ? this.$refs.grid.getSelectedRecords() : this.jsondata
      let functionName = ''
      switch (type) {
        case 'cargarCompras':
          functionName = 'confirmPurchaseAlmacen'
          msg = '<div class="text-center"><h4>Por favor Confirme que desea realizar la carga de esta compra.</h4><br> <h6><span style="color: red">Tome en cuenta que se realizara la carga de las empresas o sucursales afectadas.</span></h6></div>'
          break
        case 'save':
          functionName = 'updateOrders'
          msg = '<div class="text-center"><h4>Por favor Confirme que desea guardar los cambios efectuados</h4></div>'
          break
        default:
          break
      }
      this.$dialog.confirm(msg)
        .then(async () => {
          const info = []
          console.log('this.enterprises', this.enterprises)
          for (let index = 0; index < this.enterprises.length; index++) {
            if (type === 'cargarCompras') {
              functionName = 'confirmPurchaseAlmacen'
              // this.dataEnterprises[this.enterprises[index].id].cargarCompras = true
              const datos = this.jsondata
              console.log('datos', datos)
              const items = []
              for (let i = 0; i < datos.length; i++) {
                console.log('parseFloat(datos[i].precio)', datos[i], parseFloat(datos[i].precio))
                if (parseFloat(datos[i].precio) > 0) {
                  datos[i].status = 1 // estatus de compra para detalle de inventario
                  items.push(datos[i])
                }
              }
              info.rows = items
              info.cargarCompras = true
              info.userId = this.user.userId
              info.enterpriseId = this.user.enterprise_id
            } else {
              info.rows = this.dataEnterprises[this.enterprises[index].id]
              info.cargarCompras = false
            }
            console.log('this.dataEnterprises[this.enterprises[index].id]', info, functionName, this.dataEnterprises[this.enterprises[index].id])
            if (info.rows.length > 0) {
              console.log('* * * * * ************** SAVE * * * * **********', info)
              await this.save(functionName, info)
              // if (Stocktaking) {
              //   await this.save('setInventory', info)
              //   this.$router.push({ name: 'labelsOrders', params: info })
              // }
            } else {
              console.log('no hay elementos a guardar', info)
              this.$toastedPush({
                message: 'No hay elementos a guardar, por favor verifique sus datos..',
                type: 'error'
              })
            }
          }
          if (type === 'cargarCompras' && info.length > 0) {
            this.cargarCompras(info)
          }
          // this.save(false, functionName)
        })
        .catch((err) => {
          console.log('presiono cancelar confirmationDialog', err)
        })
    },
    async setFaltantes (ref) {
      console.log('this.$refs[ref][0]', this.$refs[ref][0].getSelectedRecords())
      const data = this.$refs[ref][0].getSelectedRecords()
      console.log('setFaltantes', data)
      if (data.length > 0) {
        this.$dialog.confirm('<div class="text-center"><h4>Por favor Confirme que los productos seleccionados son faltantes</h4></div>')
          .then(async () => {
            const items = {
              data: data
            }
            const response = await axiosAdelaService.post('/updateOrderFaltante', items)
            console.log('updateOrderFaltante', response)
            if (response.status === 200) {
              if (response.data) {
                await this.getOrdersForEnterprises()
                this.$toastedPush({
                  message: 'Se cambio es estatus del pedido a Faltantes.',
                  type: 'success'
                })
              }
            }
          })
          .catch((err) => {
            console.log('presiono cancelar confirmationDialog', err)
          })
      } else {
        this.$toastedPush({
          message: 'No hay elementos a guardar, por favor seleccione al menos un elemento',
          type: 'error'
        })
      }
    },
    async save (functionName, data) {
      const items = {
        id_provider: this.id_provider,
        data: data.rows,
        cargarCompras: data.cargarCompras,
        enterprise: this.user.enterprise_id,
        user_id: this.user.user_admin_id,
        buyDay: this.today
      }
      console.log(items)
      const response = await axiosAdelaService.post(`/${functionName}`, items)
      console.log(`**** ${functionName}`, response)
      if (response.status === 200) {
        if (response.data.addInventory !== undefined) {
          this.$router.push({ name: 'labelsOrders', params: data })
        }
        this.$toastedPush({
          message: 'Se actualizaron las ordenes seleccionadas.',
          type: 'success'
        })
        this.getOrdersForEnterprises()
      }
    },
    changeMayoreo (...args) {
    },
    changeDiscount (...args) {
      const costo = args[2].precio
      const porcentageDescuento = args[0]
      const descuentoPesos = costo * (porcentageDescuento / 100)
      args[2].descuento = descuentoPesos.toFixed(2)
      args[2].venta = (costo - descuentoPesos).toFixed(2)
    },
    changeDiscountAbout (...args) {
      const costo = args[2].precio
      const porcentageDescuento = args[0]
      const descuentoPesos = costo * (porcentageDescuento / 100)
      // args[2].costo_tienda = (costo - descuentoPesos).toFixed(2)
      args[2].descuento_nosotros = (descuentoPesos).toFixed(2)
    },
    changeCost (...args) {
      const costo = args[0]
      const porcentageDescuento = args[2].porcentaje_descuento
      const descuentoPesos = costo * (porcentageDescuento / 100)
      args[2].descuento = descuentoPesos.toFixed(2)
      args[2].venta = (costo - descuentoPesos).toFixed(2)
      args[2].precio = parseFloat(args[0]).toFixed(2)

      // calculo de costo de tienda
      const descuentoTienda = parseFloat(args[2].porcentaje_descuento_nosotros)
      const costoTienda = costo * (descuentoTienda / 100)
      args[2].descuento_nosotros = costoTienda.toFixed(2)
      // args[2].costo_tienda = costo - costoTienda
      this.calculeGeneralCost()
    },
    changeModel (...args) {
      console.log('changeModel', args)
      const detail = args[0].split('-')
      console.log('Cuantos trae', detail)
      if (detail.length > 1) {
        args[2].order_id = parseInt(detail[0])
        args[2].modelo = parseInt(detail[1])
      }
    },
    changeDiscountMoney (...args) {
      const descuentoPesos = parseFloat(args[0]).toFixed(2)
      const costo = args[2].precio
      const porcentageDescuento = (descuentoPesos * 100) / costo
      args[2].porcentaje_descuento = porcentageDescuento.toFixed(2)
      args[2].venta = (costo - descuentoPesos).toFixed(2)
    },
    changeClientPrice (...args) {
      // const costo = args[2].precio
      // const venta = parseFloat(args[0]).toFixed(2)
      // const porcentageDescuento = 100 - ((100 * venta) / costo)
      // args[2].porcentaje_descuento = porcentageDescuento.toFixed(2)
      // const descuentoPesos = costo * (porcentageDescuento / 100)
      // args[2].descuento = descuentoPesos.toFixed(2)

      // test de como seria si se tiene que obtener el costo del producto apartir de el precio de venta al cliente
      const precioVenta = parseFloat(args[0])
      const porcentageDescuento = parseFloat(args[2].porcentaje_descuento)
      const costo = precioVenta / (1 - (porcentageDescuento / 100))
      // console.log('costo', costo, 'porcentageDescuento', porcentageDescuento, 'precioVenta', precioVenta, args)
      const porcentageDescuentoPesos = costo * (porcentageDescuento / 100)
      args[2].precio = costo.toFixed(2)
      args[2].descuento = porcentageDescuentoPesos.toFixed(2)
      this.calculeGeneralCost()
    },
    async changeCostoTienda (...args) {
      // const costoTienda = parseFloat(args[0])
      // const descuentoAbout = parseFloat(args[2].porcentaje_descuento_nosotros)
      // // console.log('descuento nosotros * * * * ', descuentoAbout, costoTienda * (descuentoAbout / 100))
      // const descuentoNosotros = costoTienda * (descuentoAbout / 100)
      // const precioCliente = parseFloat(costoTienda + (costoTienda * (descuentoAbout / 100)))
      // const porcentageDescuento = args[2].porcentaje_descuento
      // const descuentoPesos = precioCliente * (porcentageDescuento / 100)
      // args[2].descuento_nosotros = descuentoNosotros.toFixed(2)
      // args[2].descuento = descuentoPesos.toFixed(2)
      // args[2].venta = (precioCliente - descuentoPesos).toFixed(2)
      // args[2].precio = precioCliente.toFixed(2)
      args[2].costo_tienda = parseFloat(args[0])
      // console.log(args)
      await this.calculeGeneralCost()
    },
    async changeAlmacen (...args) {
      console.log('* * * ** updateALMACEN Value', args)
      // const reformattedArray = this.options.find(el => {
      //   return parseInt(el.name) === parseInt(args[0])
      // })
      const detail = args[0].split('-')
      args[2].almacen = detail[1]
      args[2].almacen_id = detail[0]
      if (args[2].provider_id !== undefined && args[2].almacen_id !== undefined) {
        this.modelOptions.splice(0, this.modelOptions.length)
        await this.searchProductAlmacen(parseInt(args[2].almacen_id), parseInt(args[2].provider_id))
      }
    },
    async changeProveedor (...args) {
      console.log('* * * ** updateALMACEN Value', args)
      // const reformattedArray = this.options.find(el => {
      //   return parseInt(el.name) === parseInt(args[0])
      // })
      const detail = args[0].split('-')
      console.log('detail provider ', detail)
      args[2].proveedor = detail[1]
      const idProvider = this.allProviders.find(el => el.key_provider === detail[0])
      // args[2].provider_id = detail[0]
      args[2].provider_id = idProvider.id_provider
      args[2].porcentaje_descuento = idProvider.discount_client
      args[2].porcentaje_descuento_nosotros = idProvider.discount
      console.log('proveedor id', idProvider)
      if (args[2].provider_id !== undefined && args[2].almacen_id !== undefined) {
        this.modelOptions.splice(0, this.modelOptions.length)
        await this.searchProductAlmacen(parseInt(args[2].almacen_id), parseInt(args[2].provider_id))
      }
    },
    async searchProductAlmacen (almacenId, providerId) {
      // modelOptions = []
      const items = {
        provider_id: providerId,
        almacen_id: almacenId,
        id_empresa: this.user.enterprise_id
      }
      console.log('searchProductAlmacen items', items)
      const response = await axiosAdelaService.post('/searchProductAlmacen', items)
      console.log('searchProductAlmacen', response)
      if (response.status === 200) {
        if (response.data.length > 0) {
          for (const key in response.data) {
            this.modelOptions.push(response.data[key].modelo)
          }
        }
      }
    },
    async calculeGeneralCost () {
      let precio = 0
      console.log(this.jsondata)
      this.jsondata.forEach(element => {
        console.log(element)
        precio += (parseFloat(element.costo_tienda) * parseFloat(element.cantidad))
      })
      this.generalCost = precio.toFixed(2)
    },
    async cargarCompras () {
      const data = []
      this.jsondata.forEach(el => {
        if (el.almacen_id !== undefined && el.provider_id !== undefined) {
          data.push(el)
        }
      })
      const items = {
        id_empresa: this.user.enterprise_id,
        user_id: this.user.user_admin_id,
        data: data,
        buyDay: this.today
      }
      console.log('Items', items)
      const response = await axiosAdelaService.post('/confirmPurchaseAlmacen', items)
      console.log('confirmPurchaseAlmacen', response)
      if (response.status === 200) {
        if (response.data) {
          this.jsondata = []
          this.$toastedPush({
            message: 'Se cargo la compra correctamente',
            type: 'success'
          })
        }
      }
    },
    async getAlmacenes () {
      const response = await axiosAdelaService.post('/getAlmacenes')
      console.log('Estos son los almacenes', response.data)
      if (response.status === 200) {
        response.data.rows.forEach(element => {
          this.options.push({ text: element.name, value: element.id })
          this.almacenes.push(element.id + '-' + element.name)
        })
        const tem = this.almacenes.filter(el => el !== '1-CLIENTES')
        this.almacenes = tem
        // this.enterprises = response.data
      }
    },
    async getProviders () {
      const response = await axiosAdelaService.post('/getProviders')
      console.log('Estos son los getProviders', response.data)
      if (response.status === 200) {
        this.allProviders = response.data.rows
        response.data.rows.forEach(el => {
          this.proveedores.push(el.key_provider + '-' + el.name)
        })
        // this.enterprises = response.data
      }
    },
    addRow () {
      this.jsondata.push({
        id_client: '',
        fullname: '',
        marca: '',
        modelo: '',
        color: '',
        numero: '',
        precio: '',
        porcentaje_descuento: '',
        descuento: '',
        venta: '',
        porcentaje_descuento_nosotros: '',
        costo_tienda: '',
        delivery_date: '',
        catalogo: 'S/C ALMACEN',
        pagina: 0,
        comentario: '',
        cantidad: 1,
        id_provider: '',
        status: 8
      })
    }
  },
  async mounted () {
    this.selected.push(this.user.enterprise_id)
    await this.getProviders()
    await this.getAlmacenes()
    this.nameMarca = this.$route.params.marca
    this.id_provider = this.$route.params.id_provider
  }
}
</script>

<style>
.btnGenerateBuy {
  display: inline-block;
}
.fontButt {
  font-size: 10px;
  margin: auto;
}
.fontIconBtn {
  font-size: 22px;
  font-weight: bold;
}
</style>
